"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "flex flex-row items-center gap-1 h-full border-gray focus-within:ring-blue focus-within:ring-opacity-50 rounded-md transition-all duration-300" };
const _hoisted_3 = ["id"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
    key: 1,
    class: "bg-white text-center p-2 border-t border-gray cursor-pointer hover:bg-gray"
};
const debounce_1 = __importDefault(require("lodash/debounce"));
const vue_3 = require("vue");
const ShopInput_vue_1 = __importDefault(require("../ShopInput.vue"));
const validators_1 = require("../../../common/utils/validators");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AsyncSearchInput',
    props: {
        placeholder: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        displayValue: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        required: Boolean,
        maxLength: {
            type: Number,
            required: false,
            default: 9000,
        },
        customClass: {
            type: String,
            required: false,
            default: "",
        },
        debounceInMs: {
            type: Number,
            default: 300,
        },
        displayValueAfterSelection: {
            type: Boolean,
            default: false,
            required: false,
        },
        showValidity: {
            type: Boolean,
            default: false,
        },
        invalidMessage: {
            type: String,
            required: false,
            default: "",
        },
    },
    emits: ["searchedValueChanged", "selected"],
    setup(__props, { expose: __expose, emit }) {
        var _a;
        const props = __props;
        // eslint-disable-next-line vue/no-dupe-keys
        const displayValue = (0, vue_3.ref)(props.displayValue);
        const searchedValue = (0, vue_3.ref)("");
        const searchVisible = (0, vue_3.ref)(false); //Dont change the v-show to v-if!
        const componentId = (_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid;
        let searcher = null;
        let searcherInput = null;
        const openSearcher = () => {
            searchVisible.value = true;
            (0, vue_3.nextTick)(() => {
                searcherInput = document.getElementById(`searcher_input_${componentId}`);
                if (searcherInput === null) {
                    return;
                }
                searcherInput.focus();
            });
        };
        const clickOutsideListener = (event) => {
            if (searcher !== null && !searcher.contains(event.target)) {
                searchVisible.value = false;
                searchedValue.value = "";
                return;
            }
        };
        (0, vue_3.onMounted)(() => {
            searcher = document.getElementById(`searcher_${componentId}`);
            document.addEventListener("click", clickOutsideListener);
        });
        (0, vue_3.onUnmounted)(() => {
            document.removeEventListener("click", clickOutsideListener);
        });
        (0, vue_3.watch)(searchedValue, (0, debounce_1.default)((value) => {
            if (value === "") {
                return;
            }
            emit("searchedValueChanged", searchedValue.value);
        }, props.debounceInMs));
        const itemSelected = (item) => {
            displayValue.value = props.displayValueAfterSelection
                ? item.value
                : item.label;
            searchedValue.value = "";
            emit("selected", item);
        };
        const setDisplayValue = (value) => {
            displayValue.value = value;
        };
        const searcherKeydown = (event) => {
            if (event.key === "Tab") {
                searchVisible.value = false;
            }
        };
        __expose({ setDisplayValue });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: `searcher_${(0, vue_2.unref)(componentId)}`,
                class: "relative w-full"
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                        modelValue: displayValue.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((displayValue).value = $event)),
                        type: "text",
                        placeholder: __props.placeholder,
                        label: __props.label,
                        readonly: "",
                        class: "h-full",
                        autocomplete: false,
                        border: "",
                        required: __props.required,
                        "max-length": __props.maxLength,
                        "show-validity": __props.showValidity,
                        valid: !(0, vue_2.unref)(validators_1.isBlank)(displayValue.value),
                        "invalid-message": __props.invalidMessage,
                        icon: "marso-icon-search",
                        onFocusin: openSearcher
                    }, null, 8, ["modelValue", "placeholder", "label", "required", "max-length", "show-validity", "valid", "invalid-message"])
                ]),
                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("ul", {
                    class: (0, vue_2.normalizeClass)(["absolute left-0 z-10 w-full bg-white block shadow-sm", __props.customClass])
                }, [
                    (0, vue_2.createElementVNode)("li", null, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            id: `searcher_input_${(0, vue_2.unref)(componentId)}`,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchedValue).value = $event)),
                            class: "w-full p-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-300 border-blue border-2",
                            onKeydown: searcherKeydown
                        }, null, 40, _hoisted_3), [
                            [vue_2.vModelText, searchedValue.value]
                        ])
                    ]),
                    (__props.options.length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, (0, vue_2.renderList)(10, (i) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: i }, [
                                (__props.options[i - 1])
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                        key: 0,
                                        class: "p-2 hover:bg-gray cursor-pointer",
                                        onClick: ($event) => (itemSelected(__props.options[i - 1]))
                                    }, (0, vue_2.toDisplayString)(__props.options[i - 1].label), 9, _hoisted_4))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ], 64));
                        }), 64))
                        : (0, vue_2.createCommentVNode)("", true),
                    (__props.options.length > 10)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_5, " ... "))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 2), [
                    [vue_2.vShow, searchVisible.value]
                ])
            ], 8, _hoisted_1));
        };
    }
});
